import React, { useEffect, useRef } from 'react';
import lootie from 'lottie-web'
import './Home.css'

const HomeFirst = () => {
    const container = useRef(null)
    useEffect(() => {
        lootie.loadAnimation({
            container: container.current,
            renderer: 'svg',
            width: '100%',
            loop: true,
            autoplay: true,
            animationData: require('../Componenet/lll.json.json')
        })
    })
    return (
        <div  className="mainhe my-2">
            <div className=" ">
                <div className='l2' ref={container} ></div>
            </div >
        </div >
    );
};

export default HomeFirst;